import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const OPS_VIEWS_VOCABULARIES = [
    vocabulary('ride.execution_phase', '@vello/ride-execution RIDE_EXECUTION_PHASES', {
        requested: L('Solicitada', 'Requested', 'Solicitado', 'Richiesta'),
        searching: L('Procurando motorista', 'Finding a driver', 'Buscando conductor', 'Ricerca autista'),
        no_driver: L('Sem motorista', 'No driver found', 'Sin conductor', 'Nessun autista'),
        assigned: L('Motorista atribuído', 'Driver assigned', 'Conductor asignado', 'Autista assegnato'),
        en_route: L('A caminho do embarque', 'On the way to pickup', 'En camino a la recogida', 'In arrivo al ritiro'),
        arrived: L('Motorista no local', 'Driver arrived', 'Conductor en el lugar', 'Autista arrivato'),
        waiting: L('Aguardando o passageiro', 'Waiting for the rider', 'Esperando al pasajero', 'In attesa del passeggero'),
        pin_pending: L('Aguardando o PIN', 'Waiting for the PIN', 'Esperando el PIN', 'In attesa del PIN'),
        pin_verified: L('PIN confirmado', 'PIN confirmed', 'PIN confirmado', 'PIN confermato'),
        in_progress: L('Em andamento', 'In progress', 'En curso', 'In corso'),
        stop_arrived: L('Chegou à parada', 'Arrived at a stop', 'Llegó a la parada', 'Arrivato alla fermata'),
        on_hold: L('Em espera', 'On hold', 'En espera', 'In attesa'),
        destination_changed: L('Destino alterado', 'Destination changed', 'Destino cambiado', 'Destinazione modificata'),
        completed: L('Concluída', 'Completed', 'Completado', 'Completata'),
        cancelled: L('Cancelada', 'Cancelled', 'Cancelado', 'Annullata'),
        no_show: L('Passageiro ausente', 'Rider did not show up', 'Pasajero ausente', 'Passeggero assente'),
    }),
    vocabulary('eligibility.source_outcome', '@vello/candidate-eligibility EligibilitySourceOutcome', {
        CLEAR: L('Liberado', 'Clear', 'Despejado', 'Via libera'),
        DENIED: L('Negado', 'Denied', 'Denegado', 'Negato'),
        UNVERIFIED: L('Não verificado', 'Unverified', 'No verificado', 'Non verificato'),
    }),
    vocabulary('eligibility.condition', '@vello/candidate-eligibility EligibilityCondition', {
        geofence: L('Área do embarque', 'Pickup area', 'Zona de recogida', 'Area di ritiro'),
        payment: L('Pagamento', 'Payment', 'Pago', 'Pagamento'),
        riderBlock: L('Bloqueio do passageiro', 'Rider block', 'Bloqueo del pasajero', 'Blocco del passeggero'),
    }),
    vocabulary('notification.channel', '@vello/notifications NOTIFICATION_CHANNELS', {
        PUSH: L('Notificação push', 'Push notification', 'Notificación push', 'Notifica push'),
        SMS: L('Mensagem de texto (SMS)', 'Text message (SMS)', 'Mensaje de texto (SMS)', 'Messaggio di testo (SMS)'),
        EMAIL: L('E-mail', 'Email', 'Correo electrónico', 'E-mail'),
        WHATSAPP: L('WhatsApp', 'WhatsApp', 'WhatsApp', 'WhatsApp'),
        IN_APP: L('No aplicativo', 'In the app', 'En la app', 'Nell’app'),
    }),
    vocabulary('notification.preference_channel', '@vello/food-support NOTIFICATION_CHANNELS', {
        push: L('Notificação push', 'Push notification', 'Notificación push', 'Notifica push'),
        sms: L('SMS', 'SMS', 'SMS', 'SMS'),
        email: L('E-mail', 'Email', 'Correo electrónico', 'E-mail'),
        in_app: L('No aplicativo', 'In the app', 'En la app', 'Nell’app'),
        voice: L('Ligação de voz', 'Voice call', 'Llamada de voz', 'Chiamata vocale'),
    }),
    vocabulary('support.transcript_actor', '@vello/food-support TRANSCRIPT_ACTORS', {
        customer: L('Cliente', 'Customer', 'Cliente', 'Cliente'),
        operator: L('Atendente', 'Agent', 'Agente', 'Operatore'),
        ai: L('Assistente de IA', 'AI assistant', 'Asistente de IA', 'Assistente IA'),
        supervisor: L('Supervisor', 'Supervisor', 'Supervisor', 'Supervisore'),
        system: L('Sistema', 'System', 'Sistema', 'Sistema'),
    }),
    vocabulary('food.support_journey', '@vello/food-support SUPPORT_JOURNEYS', {
        late_order: L('Pedido atrasado', 'Late order', 'Pedido retrasado', 'Ordine in ritardo'),
        missing_item: L('Item faltando', 'Missing item', 'Artículo faltante', 'Articolo mancante'),
        substitution: L('Substituição de item', 'Item substitution', 'Sustitución de artículo', 'Sostituzione di un articolo'),
        refund: L('Reembolso', 'Refund', 'Reembolso', 'Rimborso'),
    }),
    vocabulary('support.sla_state', '@vello/food-support SLA_STATES', {
        on_track: L('No prazo', 'On track', 'En plazo', 'Nei tempi'),
        at_risk: L('Em risco', 'At risk', 'En riesgo', 'A rischio'),
        breached: L('Prazo estourado', 'Breached', 'Plazo incumplido', 'Scaduto'),
    }),
    vocabulary('geo.capability', '@vello/geo GEO_CAPABILITIES', {
        geocoder: L('Busca de endereços', 'Address search', 'Búsqueda de direcciones', 'Ricerca indirizzi'),
        places: L('Busca de lugares', 'Places search', 'Búsqueda de lugares', 'Ricerca luoghi'),
        routing: L('Rotas', 'Routing', 'Rutas', 'Percorsi'),
        matrix: L('Matriz de distâncias', 'Distance matrix', 'Matriz de distancias', 'Matrice delle distanze'),
        tiles: L('Mapa', 'Map tiles', 'Mapa', 'Mappa'),
        navigation: L('Navegação', 'Navigation', 'Navegación', 'Navigazione'),
    }),
    vocabulary('geo.precision', '@vello/geo Precision', {
        precise: L('Preciso', 'Precise', 'Preciso', 'Preciso'),
        interpolated: L('Interpolado', 'Interpolated', 'Interpolado', 'Interpolato'),
        centroid: L('Centro da área', 'Area center', 'Centro del área', 'Centro dell’area'),
        approximate: L('Aproximado', 'Approximate', 'Aproximado', 'Approssimato'),
    }),
    vocabulary('provider.capability', '@vello/providers PROVIDER_CAPABILITIES', {
        maps: L('Mapas', 'Maps', 'Mapas', 'Mappe'),
        geocoder: L('Geocodificação', 'Geocoding', 'Geocodificación', 'Geocodifica'),
        routing: L('Rotas', 'Routing', 'Rutas', 'Percorsi'),
        notification: L('Notificações', 'Notifications', 'Notificaciones', 'Notifiche'),
        kyc: L('Verificação de identidade', 'Identity verification', 'Verificación de identidad', 'Verifica dell’identità'),
        storage: L('Armazenamento', 'Storage', 'Almacenamiento', 'Archiviazione'),
        psp: L('Pagamentos (PSP)', 'Payments (PSP)', 'Pagos (PSP)', 'Pagamenti (PSP)'),
    }),
    vocabulary('driver.availability_state', '@vello/driver-availability AVAILABILITY_STATES', {
        offline: L('Offline', 'Offline', 'Fuera de línea', 'Offline'),
        going_online: L('Ficando online', 'Going online', 'Conectándose', 'In connessione'),
        available: L('Disponível', 'Available', 'Disponible', 'Disponibile'),
        offered: L('Recebendo oferta', 'Receiving an offer', 'Recibiendo una oferta', 'Offerta in arrivo'),
        assigned: L('Corrida atribuída', 'Ride assigned', 'Viaje asignado', 'Corsa assegnata'),
        on_trip: L('Em corrida', 'On a trip', 'En viaje', 'In corsa'),
        paused: L('Em pausa', 'Paused', 'En pausa', 'In pausa'),
        on_break: L('Em intervalo', 'On a break', 'En descanso', 'In pausa pranzo'),
        destination: L('Indo para o destino', 'Heading to destination', 'Yendo al destino', 'Verso la destinazione'),
        forced_offline: L('Desconectado pela operação', 'Taken offline by operations', 'Desconectado por la operación', 'Disconnesso dalle operazioni'),
    }),
];
//# sourceMappingURL=ops-views.js.map